import { AuthorizedRoute } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import { withRouter } from 'Lib/hoc';
import ManageUsersView from 'Pages/Admin/ManageUsersView';
import UserDetailsPage from 'Pages/Admin/Users/UserDetailsPage';
import { Route, Routes } from 'react-router';

let UserDetailWithRouter = withRouter(UserDetailsPage);

const Users = () => {
  return (
    <Routes>
      <Route
        path=''
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <ManageUsersView />
          </AuthorizedRoute>
        }
      />
      <Route
        path=':id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <UserDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Users);
export default Page;
